export { UpsellProducts } from './UpsellProducts';
export type { UpsellProductsProps } from './UpsellProducts';
